module.exports = __webpack_public_path__ + "static/records-background-34aebb4eabf008c4361bccfa1e129a5f.png";